
        import * as module0 from '$components/dark_mode/scheme_selector.js'
        const modules = {
            "dark_mode/scheme_selector.js": module0,
        };
        export default modules;
      